import React from 'react';
import ProductVoting from './ProductVoting';

function App() {
    return (
        <div className="App">
            <ProductVoting />
        </div>
    );
}

export default App;
